import DiscontinuationBanner from './DiscontinuationBanner'

export default DiscontinuationBanner
